<div class="section-title">Sensor Failures for {{asset.asset_name}}</div>

@if (pageLogs === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Loading sensor failures...
	</div>
}

@if (pageLogs && pageLogs.length === 0) {
	<div class="loading-status">
		No failures recorded
	</div>
}

@if (pageLogs && pageLogs.length > 0) {
	<table class="log compact" [class.loading]="pageLoading">
		<thead>
			<tr>
				<th>Timestamp</th>
				<th>Device</th>
				<th>Device ID</th>
				<th>Type</th>
				<th>Status</th>
			</tr>
		</thead>
		@for (log of pageLogs; track log) {
			<tbody>
				<tr>
					<td>{{log.ts | datetime : "offset" : asset.time_offset_hours}}</td>
					<td>{{log.device_name}}</td>
					<td>{{log.device}}</td>
					<td>{{log.source}}</td>
					<td>{{log.status}}</td>
				</tr>
			</tbody>
		}
	</table>
	<ngb-pagination [collectionSize]="totalLogs" [pageSize]="itemsPerPage" [(page)]="currentPage" (pageChange)="updatePage()" [maxSize]="10" [directionLinks]="true"
		[rotate]="true"></ngb-pagination>
}